import {GetServicesMedicalGuide} from 'domain/usecases';
import {RemoteGetServicesMedicalGuide} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetServicesMedicalGuide = (): GetServicesMedicalGuide =>
	new RemoteGetServicesMedicalGuide(
		makeBFFApiUrl(GuideFlowEndpoints.medicalGuideServices),
		makeAuthorizeHttpClientDecorator(),
	);
